export function composition(...fns: any[]) {
  return (value: any) => {
    return fns.reduce((acc, fn) => fn(acc), value);
  };
}
